import * as React from 'react';
import { Marker, NavigationControl, StaticMap, ViewStateChangeInfo } from 'react-map-gl';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { GeoValidationError } from 'src/views/cPAllLocations/CPAllLocations';
import { BasedataParams, Image, Location, ServerResponse, UploadImage } from '../../api';
import ErrorBox from '../../components/errorBox/ErrorBox';
import ErrorMessage from '../../components/errorMessage/ErrorMessage';
import { MAPBOX_ACCESS_TOKEN } from '../../constants';
import FAIcon from '../fAIcon/FAIcon';
import ImageChooserMultiple from '../imageChooser/ImageChooserMultiple';
import ImagePlaceholder from '../imageChooser/ImagePlaceholder';
import './CPLocationComponent.css';

interface IState {}
interface CPLocationComponentProps {
    addUploadImage: (image: UploadImage) => void;
    cancelHandler: () => void;
    changeHandler: (editValue: string, field: string) => void;
    deleteImageHandler: (index: number) => void;
    deleteUploadImage: (index: number) => void;
    editState: EditState;
    entryId: number;
    error: boolean;
    errors: string[];
    geoAccuracyError: boolean;
    geoCalculate: () => void;
    geoValidationErrors: GeoValidationError;
    serverResponse: ServerResponse | undefined;
    location: Location;
    locationPossibleParticularities: BasedataParams;
    editValue: Location;
    errorClass: (fieldname: string) => string;
    saveHandler: () => void;
    selectEntry: (entryId: number, selectionMethod: SelectionMethod) => void;
    toggleLocationParticularity: (locationParticularity: number) => void;
    updateViewport: (info: ViewStateChangeInfo) => void;
    uploadImages: UploadImage[];
    zoomEditValue: number;
    zoomLocation: number;
}

enum EditState {
    None,
    This,
    Other,
}

enum SelectionMethod {
    Delete,
    Edit,
}

export default class CPLocationComponent extends React.Component<CPLocationComponentProps, IState> {
    private myMapRef = React.createRef<StaticMap>();
    private myEditMapRef = React.createRef<StaticMap>();

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render() {
        const viewportRead = {
            height: '30vh',
            latitude: this.props.location.Lat,
            longitude: this.props.location.Long,
            width: '25vw',
            zoom: this.props.zoomLocation,
        };
        const viewportEditing = {
            height: '30vh',
            latitude: this.props.editValue.Lat,
            longitude: this.props.editValue.Long,
            width: '25vw',
            zoom: this.props.zoomEditValue,
        };
        if (this.props.editState === EditState.None || this.props.editState === EditState.Other) {
            return (
                <>
                    <Row className={'mb-50 ph-15'}>
                        <Col className={'CPLocationComponent'} md={12}>
                            <Row>
                                <Col md={7}>
                                    <Row>
                                        <Col>
                                            <Label className="font-weight-bold">
                                                {TR.cPLocationComponent_location_name}
                                            </Label>
                                            <p>{this.props.location.Name}</p>
                                        </Col>
                                        <Col>
                                            <Label className="font-weight-bold">
                                                {TR.cPLocationComponent_telephone}
                                            </Label>
                                            <p>{this.props.location.Telephone}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label className="font-weight-bold">{TR.cPLocationComponent_street}</Label>
                                            <p>{this.props.location.Street}</p>
                                        </Col>
                                        <Col>
                                            <Label className="font-weight-bold">
                                                {TR.cPLocationComponent_postal_code}
                                            </Label>
                                            <p>{this.props.location.Zip}</p>
                                        </Col>
                                        <Col>
                                            <Label className="font-weight-bold">{TR.cPLocationComponent_city}</Label>
                                            <p>{this.props.location.City}</p>
                                        </Col>
                                        <Col>
                                            <Label className="font-weight-bold">{TR.cPLocationComponent_country}</Label>
                                            <p>{this.props.location.Country}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {this.props.location.Images.map((image: Image, index: number) => {
                                            return (
                                                <Col key={image.ID} md={3} className="mb-3">
                                                    <ImagePlaceholder image={image} />
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </Col>
                                <Col md={4} className={'mapCol'}>
                                    <Row>
                                        <Col style={{ display: 'flex', justifyContent: 'center' }}>
                                            <StaticMap
                                                {...viewportRead}
                                                mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN}
                                                onLoad={this.changeLanguage}
                                                ref={this.myMapRef}
                                            >
                                                <Marker
                                                    latitude={viewportRead.latitude}
                                                    longitude={viewportRead.longitude}
                                                    offsetTop={-10}
                                                >
                                                    <FAIcon icon="arrow-down" className={'mapMarker'} />
                                                </Marker>
                                            </StaticMap>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={1} className={'iconCol'}>
                                    {this.props.editState === EditState.None && (
                                        <>
                                            <Row>
                                                <Col>
                                                    <a
                                                        onClick={() => {
                                                            this.props.selectEntry(
                                                                this.props.entryId,
                                                                SelectionMethod.Edit
                                                            );
                                                        }}
                                                    >
                                                        <FAIcon icon="edit" />
                                                    </a>
                                                    <a
                                                        onClick={() => {
                                                            this.props.selectEntry(
                                                                this.props.entryId,
                                                                SelectionMethod.Delete
                                                            );
                                                        }}
                                                    >
                                                        <FAIcon icon="trash" />
                                                    </a>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>
                                            <Label className={'font-weight-bold'}>Besonderheiten</Label>
                                        </Col>
                                    </Row>
                                    {this.props.location.Particulatities.length === 0 && (
                                        <Row>
                                            <Col>
                                                <p>{TR.cPLocationComponent_nothing_special}</p>
                                            </Col>
                                        </Row>
                                    )}
                                    {this.props.locationPossibleParticularities.Data.map((lp) => {
                                        return (
                                            <Row
                                                key={lp.Content + lp.ID}
                                                hidden={this.props.location.Particulatities.indexOf(lp.ID) === -1}
                                            >
                                                <Col style={{ paddingLeft: '30px' }}>
                                                    <Label check={true}>
                                                        <Input
                                                            type="checkbox"
                                                            disabled={true}
                                                            style={{ marginRight: '10px' }}
                                                            checked={
                                                                this.props.location.Particulatities.indexOf(lp.ID) > -1
                                                            }
                                                        />
                                                        {lp.Content}
                                                    </Label>
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            );
        } else {
            const error = this.props.error;

            return (
                <>
                    <Row className={'ph-15'}>
                        <Col className={'CPLocationComponent'} md={12}>
                            <Row>
                                <Col md={7}>
                                    <Row style={{ marginBottom: '8px' }}>
                                        <Col md={6}>
                                            <Label
                                                className={error ? this.props.errorClass('Name') : 'font-weight-bold'}
                                            >
                                                {TR.cPLocationComponent_name_location}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.Name}
                                                onChange={(e) =>
                                                    this.props.changeHandler(e.currentTarget.value, 'Name')
                                                }
                                            />
                                        </Col>
                                        <Col md={5}>
                                            <Label
                                                className={
                                                    error ? this.props.errorClass('Telephone') : 'font-weight-bold'
                                                }
                                            >
                                                {TR.cPLocationComponent_telephone}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.Telephone}
                                                onChange={(e) =>
                                                    this.props.changeHandler(e.currentTarget.value, 'Telephone')
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <Label
                                                className={
                                                    error
                                                        ? this.props.errorClass('Street')
                                                        : this.props.geoValidationErrors.street
                                                        ? 'error'
                                                        : 'font-weight-bold'
                                                }
                                            >
                                                {TR.cPLocationComponent_street_housenr}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.Street}
                                                onChange={(e) =>
                                                    this.props.changeHandler(e.currentTarget.value, 'Street')
                                                }
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Label
                                                className={
                                                    error
                                                        ? this.props.errorClass('Zip')
                                                        : this.props.geoValidationErrors.zip
                                                        ? 'error'
                                                        : 'font-weight-bold'
                                                }
                                            >
                                                {TR.cPLocationComponent_postal_code}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.Zip}
                                                onChange={(e) => this.props.changeHandler(e.currentTarget.value, 'Zip')}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label
                                                className={
                                                    error
                                                        ? this.props.errorClass('City')
                                                        : this.props.geoValidationErrors.city
                                                        ? 'error'
                                                        : 'font-weight-bold'
                                                }
                                            >
                                                {TR.cPLocationComponent_city}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.City}
                                                onChange={(e) =>
                                                    this.props.changeHandler(e.currentTarget.value, 'City')
                                                }
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label
                                                className={
                                                    error
                                                        ? this.props.errorClass('Country')
                                                        : this.props.geoValidationErrors.country
                                                        ? 'error'
                                                        : 'font-weight-bold'
                                                }
                                            >
                                                {TR.cPLocationComponent_country}
                                            </Label>
                                            <Input
                                                value={this.props.editValue.Country}
                                                onChange={(e) =>
                                                    this.props.changeHandler(e.currentTarget.value, 'Country')
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <Button
                                                className="mt-2 mb-1 mr-1"
                                                size="sm"
                                                onClick={() => this.props.geoCalculate()}
                                                style={{ paddingLeft: '27px', paddingRight: '27px' }}
                                            >
                                                {TR.cPLocationComponent_show_on_map}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 mb-2">
                                        <ImageChooserMultiple
                                            images={this.props.editValue.Images}
                                            uploadImages={this.props.uploadImages}
                                            onFileChosen={this.props.addUploadImage}
                                            onDeleteImage={this.props.deleteImageHandler}
                                            onDeleteUploadImage={this.props.deleteUploadImage}
                                            placeHolderText={TR.cPLocationComponent_upload_images}
                                        />
                                    </Row>
                                </Col>
                                <Col md={5}>
                                    <Row>
                                        <Col
                                            className="mt-2 ml-2"
                                            style={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <StaticMap
                                                {...viewportEditing}
                                                mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN}
                                                ref={this.myEditMapRef}
                                                onLoad={this.changeLanguage}
                                            >
                                                <NavigationControl
                                                    showZoom={true}
                                                    onViewStateChange={(info) => {
                                                        this.props.updateViewport(info);
                                                    }}
                                                    onViewportChange={(viewport) => {
                                                        console.log(viewport);
                                                    }}
                                                />
                                                <Marker
                                                    latitude={viewportEditing.latitude}
                                                    longitude={viewportEditing.longitude}
                                                    offsetTop={-10}
                                                >
                                                    <FAIcon icon="arrow-down" className={'mapMarker'} />
                                                </Marker>
                                            </StaticMap>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>
                                            <Label className={'font-weight-bold'}>
                                                {TR.cPLocationComponent_specialties}
                                            </Label>
                                        </Col>
                                    </Row>
                                    {this.props.locationPossibleParticularities.Data.map((lp) => {
                                        return (
                                            <Row key={lp.ID + lp.Content}>
                                                <Col style={{ paddingLeft: '30px' }}>
                                                    <Label check={true}>
                                                        <Input
                                                            type="checkbox"
                                                            checked={
                                                                this.props.editValue.Particulatities.indexOf(lp.ID) > -1
                                                            }
                                                            style={{ marginRight: '10px' }}
                                                            onChange={() =>
                                                                this.props.toggleLocationParticularity(lp.ID)
                                                            }
                                                        />
                                                        {lp.Content}
                                                    </Label>
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {error === true && (
                        <Row>
                            <Col>
                                <>
                                    <ErrorBox serverResponse={this.props.serverResponse} />
                                    <ErrorMessage errors={this.props.errors} />
                                </>
                            </Col>
                        </Row>
                    )}
                    {Object.keys(this.props.geoValidationErrors).length !== 0 && (
                        <Row>
                            <Col>
                                <>
                                    <ErrorBox
                                        serverResponse={
                                            Object.keys(this.props.geoValidationErrors).length === 0
                                                ? { OK: true, Code: 0, Error: '' }
                                                : {
                                                      Code: 0,
                                                      Error: 'validation_error',
                                                      OK: false,
                                                  }
                                        }
                                    />
                                </>
                            </Col>
                        </Row>
                    )}
                    {this.props.geoAccuracyError && (
                        <Row>
                            <Col>
                                <>
                                    <ErrorBox
                                        serverResponse={{
                                            Code: 0,
                                            Error: 'geo_accuracy_error',
                                            OK: false,
                                        }}
                                    />
                                </>
                            </Col>
                        </Row>
                    )}
                    <Row className={'optionButtons mb-50'}>
                        <Col md={12} className="text-right">
                            <Button className="mt-2 mb-1 mr-1" size="sm" onClick={this.props.cancelHandler}>
                                Abbrechen
                            </Button>
                            <Button className="mt-2 mb-1" size="sm" onClick={() => this.props.saveHandler()}>
                                Speichern
                            </Button>
                        </Col>
                    </Row>
                </>
            );
        }
    }

    private changeLanguage = () => {
        const labels = [
            'tunnel-oneway-arrows-blue-minor',
            'tunnel-oneway-arrows-blue-major',
            'tunnel-oneway-arrows-white',
            'tunnel-oneway-arrows-white',
            'turning-features-outline',
            'road-oneway-arrows-blue-minor',
            'road-oneway-arrows-blue-major',
            'level-crossings',
            'road-oneway-arrows-white',
            'turning-features',
            'bridge-oneway-arrows-blue-minor',
            'bridge-oneway-arrows-blue-major',
            'bridge-oneway-arrows-white',
            'road-label-small',
            'road-label-medium',
            'road-label-large',
            'road-shields-black',
            'road-shields-white',
            'motorway-junction',
            'waterway-label',
            'rail-label',
            'water-label-sm',
            'place-residential',
            'airport-label',
            'place-islet-archipelago-aboriginal',
            'place-neighbourhood',
            'place-suburb',
            'place-hamlet',
            'place-village',
            'place-town',
            'place-island',
            'place-city-sm',
            'place-city-md-s',
            'place-city-md-n',
            'place-city-lg-s',
            'place-city-lg-n',
            'marine-label-sm-ln',
            'marine-label-sm-pt',
            'marine-label-md-ln',
            'marine-label-md-pt',
            'marine-label-lg-ln',
            'marine-label-lg-pt',
            'state-label-sm',
            'state-label-md',
            'state-label-lg',
            'country-label-sm',
            'country-label-md',
            'country-label-lg',
            'road-label-sm',
            'road-label-med',
            'poi-parks-scalerank1',
            'poi-scalerank1',
            'water-label',
            'place_label_neighborhood',
            'place_label_other',
            'place_label_city_small_s',
            'place_label_city_small_n',
            'place_label_city_medium_s',
            'place_label_city_medium_n',
            'place_label_city_large_s',
            'place_label_city_large_n',
            'marine_label_point_other',
            'marine_label_point_3',
            'marine_label_point_2',
            'marine_label_point_1',
            'marine_label_line_other',
            'marine_label_line_3',
            'marine_label_line_2',
            'marine_label_line_1',
        ];
        let map: mapboxgl.Map;
        if (this.myMapRef.current) {
            if (this.props.editState === EditState.None || this.props.editState === EditState.Other) {
                map = this.myMapRef.current!.getMap();
                labels.forEach((label: string) => {
                    map.setLayoutProperty(label, 'text-field', ['get', 'name_de']);
                });
            } else {
                map = this.myEditMapRef.current!.getMap();
                labels.forEach((label: string) => {
                    map.setLayoutProperty(label, 'text-field', ['get', 'name_de']);
                });
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/cpLocationComponent/CPLocationComponent.tsx